[
  {
    "audit_model": {
      "emit": [
        "AUDIT.CLASSIFICATION_RECEIPT"
      ]
    },
    "bridge_id": "G2.CLASSIFY_INPUT",
    "cost_model": {},
    "fills": [
      "DERIVED.EPISTEMIC.CLASSIFICATION"
    ],
    "generator": "G2",
    "mode": "immune",
    "notes": "Classify input provenance (user/retrieval/system/trusted).",
    "requires_witness": [],
    "seam": "epistemic↛authority"
  },
  {
    "audit_model": {
      "emit": [
        "AUDIT.BRIDGE_RECEIPT",
        "AUDIT.APPEND_ONLY_LOG"
      ]
    },
    "bridge_id": "G1.HTTP_GET",
    "cost_model": {
      "per_call": 1,
      "type": "token",
      "unit": "http_tokens"
    },
    "fills": [
      "SEPARATE.MIXED_SQUARE.EPISTEMIC_TO_EXEC"
    ],
    "generator": "G1",
    "mode": "contained",
    "notes": "Execute an HTTP GET syscall under explicit authority and regime constraints.",
    "requires_witness": [
      "WITNESS.POLICY_EVAL",
      "WITNESS.BUDGET_RECEIPT"
    ],
    "seam": "computation↛execution"
  },
  {
    "audit_model": {
      "emit": [
        "AUDIT.BUDGET_SPEND"
      ]
    },
    "bridge_id": "G4.HTTP_BUDGET",
    "cost_model": {
      "type": "token_pool",
      "unit": "http_tokens"
    },
    "fills": [
      "RES.CONSUME.HTTP_TOKENS"
    ],
    "generator": "G4",
    "mode": "contained",
    "notes": "Budget accounting for HTTP GET.",
    "requires_witness": [],
    "seam": "resource↛execution"
  },
  {
    "audit_model": {
      "emit": [
        "AUDIT.APPROVAL_RECEIPT"
      ]
    },
    "bridge_id": "G1.APPROVAL_WITNESS",
    "cost_model": {},
    "fills": [
      "PRECOMMIT.APPROVAL"
    ],
    "generator": "G1",
    "mode": "inert",
    "notes": "Optional human approval bridge for inert regime.",
    "requires_witness": [
      "WITNESS.HUMAN_APPROVAL"
    ],
    "seam": "control↛execution"
  }
]
